import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import LayoutDefault from '../../components/LayoutDefault';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageTitle from '../../components/PageTitle';
import NavPath from '../../components/NavPath';
import Paragraph from '../../components/Paragraph';
import FormRegistration from '../../components/FormRegistration';
import withMemo from '../../decorators/withMemo';
var ScholarshipTemplate = function ScholarshipTemplate(_ref) {
  var headerProps = _ref.headerProps,
    navPathProps = _ref.navPathProps,
    footerProps = _ref.footerProps,
    layoutProps = _ref.layoutProps,
    pageTitleProps = _ref.pageTitleProps,
    paragraphProps = _ref.paragraphProps,
    formRegistrationProps = _ref.formRegistrationProps;
  return /*#__PURE__*/React.createElement(LayoutDefault, _extends({}, layoutProps, {
    header: /*#__PURE__*/React.createElement(Header, headerProps)
    // <></>
    ,
    nav: /*#__PURE__*/React.createElement(NavPath, navPathProps),
    title: /*#__PURE__*/React.createElement(PageTitle, pageTitleProps),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, paragraphProps), /*#__PURE__*/React.createElement(FormRegistration, formRegistrationProps)),
    footer: /*#__PURE__*/React.createElement(Footer, footerProps)
  }));
};
ScholarshipTemplate.propTypes = {
  headerProps: PropTypes.any,
  navPathProps: PropTypes.any,
  footerProps: PropTypes.any,
  layoutProps: PropTypes.any,
  pageTitleProps: PropTypes.any,
  paragraphProps: PropTypes.any,
  formRegistrationProps: PropTypes.any
};
ScholarshipTemplate.defaultProps = {
  headerProps: null,
  navPathProps: null,
  footerProps: null,
  layoutProps: null,
  pageTitleProps: null,
  paragraphProps: null,
  formRegistrationProps: null
};
export default withMemo()(ScholarshipTemplate);